import { Component, OnInit } from '@angular/core';
import { CustomerService } from '../../services/customer/customer.service';

@Component({
  selector: 'app-customer-profile',
  templateUrl: './customer-profile.component.html',
  styleUrls: ['./customer-profile.component.scss']
})
export class CustomerProfileComponent implements OnInit {
  model: any = {};

  constructor(private customerService: CustomerService) {}

  loadPageData(): void {
    this.customerService.getProfile().subscribe(x => this.model = x);
  }

  save(): void {
    this.customerService.updateProfile(this.model).subscribe();
  }

  ngOnInit(): void {
    this.loadPageData();
  }
}
